import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageContent } from '@/components/layout/PageContent';
import { useMemberAccess } from '@/hooks/useMemberAccess';
import type { ModuleId } from '@finvox/shared/member-access';

export function ModuleGuard({
  moduleId,
  children
}: {
  moduleId: ModuleId;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const access = useMemberAccess();

  if (!access?.modules[moduleId]) {
    return (
      <PageContent>
        <h1 className="text-2xl font-bold">{t('errors.moduleAccessDeniedTitle')}</h1>
        <p className="mt-2 text-sm text-[var(--fv-text-muted)]">
          {t('errors.moduleAccessDeniedHint')}
        </p>
        <Link
          to="/"
          className="mt-4 inline-block text-sm font-medium text-[var(--fv-primary)] hover:underline"
        >
          {t('errors.backToDashboard')}
        </Link>
      </PageContent>
    );
  }

  return children;
}
